// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__1KLxw","mainContent":"Form_mainContent__iDHPM","sections":"Form_sections__2o3R-"};